import { render } from "./HomeIcon.vue?vue&type=template&id=5310a748"
const script = {}
script.render = render

export default script